/* Kardhini — product card behaviour.
   1. Hovering a metal swatch swaps the card image to that variant's photo.
   2. The quick-view control opens a real modal built from /products/<handle>.js
      with a working variant picker and add-to-cart. */

(function () {
  'use strict';

  /* ---------- helpers ---------------------------------------------------- */

  function money(cents) {
    var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
    try {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: code }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  /* ---------- 1. swatch hover ------------------------------------------- */

  // Delegated, so cards added later by Splide clones or the theme editor work.
  var TINTS = ['is-tint-rose', 'is-tint-white', 'is-tint-yellow'];

  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('[data-k-swatch]');
    if (!sw) return;
    var card = sw.closest('.k-pcard');
    var media = card && card.querySelector('.k-pcard__media');
    var img = media && media.querySelector('img');
    if (!img) return;

    // A real per-variant photo always wins.
    if (sw.dataset.img) {
      if (img.dataset.origSrc == null) {
        img.dataset.origSrc = img.getAttribute('src') || '';
        img.dataset.origSrcset = img.getAttribute('srcset') || '';
      }
      // srcset would otherwise win over the src we just set.
      img.removeAttribute('srcset');
      img.setAttribute('src', sw.dataset.img);
      return;
    }

    // Opt-in fallback: approximate the metal with a filter. Only runs when
    // the section has "Simulate metal colour" on, because it is an
    // approximation of a photo that does not exist, not the real piece.
    if (!card.hasAttribute('data-k-tint')) return;
    media.classList.remove.apply(media.classList, TINTS);
    media.classList.add('is-tint-' + (sw.dataset.tone || 'yellow'));
  });

  // Clicking a swatch opens that variant, so the control does something even
  // when the variants share a single photo.
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('[data-k-swatch]');
    if (!sw || !sw.dataset.url) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = sw.dataset.url;
  });

  document.addEventListener('mouseout', function (e) {
    var wrap = e.target.closest && e.target.closest('[data-k-swatches]');
    if (!wrap) return;
    if (wrap.contains(e.relatedTarget)) return; // still inside the swatch row

    var card = wrap.closest('.k-pcard');
    var media = card && card.querySelector('.k-pcard__media');
    if (media) media.classList.remove.apply(media.classList, TINTS);

    var img = media && media.querySelector('img');
    if (!img || img.dataset.origSrc == null) return;
    img.setAttribute('src', img.dataset.origSrc);
    if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
  });

  /* ---------- 2. tab filtering ------------------------------------------ */

  // Filters the slides already on the page — no navigation, no fetch. Each
  // slide carries data-cat built from its product type and tags.
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-k-tab]');
    if (!tab) return;
    e.preventDefault();

    var wrap = tab.closest('.k-wrap');
    var root = wrap && wrap.querySelector('.splide');
    var list = root && root.querySelector('.splide__list');
    if (!list) return;

    // Cache the full set once, before we start removing nodes from the DOM.
    if (!root.kSlides) {
      root.kSlides = Array.prototype.slice.call(list.children).filter(function (li) {
        return li.classList.contains('splide__slide');
      });
    }

    var term = (tab.getAttribute('data-k-tab') || '').toLowerCase().trim();
    var keep = root.kSlides.filter(function (li) {
      if (!term) return true;
      return (li.getAttribute('data-cat') || '').indexOf(term) !== -1;
    });

    wrap.querySelectorAll('[data-k-tab]').forEach(function (t) {
      t.removeAttribute('aria-current');
    });
    tab.setAttribute('aria-current', 'true');

    list.innerHTML = '';
    if (keep.length) {
      keep.forEach(function (li) { list.appendChild(li); });
    } else {
      var empty = el('li', 'splide__slide k-tab-empty', 'Nothing in this category yet.');
      list.appendChild(empty);
    }

    if (root.kSplide) {
      root.kSplide.refresh();
      root.kSplide.go(0);
    }
  });

  /* ---------- 3. quick view --------------------------------------------- */

  var modal = null;
  var lastFocus = null;

  function buildModal() {
    if (modal) return modal;
    modal = el('div', 'k-qv', '');
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<div class="k-qv__scrim" data-k-qv-close></div>' +
      '<div class="k-qv__panel" role="dialog" aria-modal="true" aria-label="Quick view">' +
      '<button class="k-qv__x" type="button" data-k-qv-close aria-label="Close">&times;</button>' +
      '<div class="k-qv__body"></div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-k-qv-close]')) close();
    });
    return modal;
  }

  function close() {
    if (!modal || modal.hasAttribute('hidden')) return;
    modal.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  function render(p) {
    var body = modal.querySelector('.k-qv__body');
    var v = p.variants[0];
    var hasOptions = p.variants.length > 1;

    var opts = '';
    if (hasOptions) {
      opts =
        '<label class="k-qv__label" for="k-qv-variant">' + (p.options[0].name || 'Option') + '</label>' +
        '<select class="k-qv__select" id="k-qv-variant">' +
        p.variants
          .map(function (x) {
            return '<option value="' + x.id + '"' + (x.available ? '' : ' disabled') + '>' +
              x.title + (x.available ? '' : ' — sold out') + '</option>';
          })
          .join('') +
        '</select>';
    }

    // Chips read better than a dropdown for two or three options, and the
    // option name doubles as the label. Above that a select stays sensible.
    var useChips = hasOptions && p.variants.length <= 4;
    if (hasOptions) {
      var label = (p.options[0] && (p.options[0].name || p.options[0])) || 'Option';
      if (useChips) {
        opts =
          '<p class="k-qv__label">' + label + '</p>' +
          '<div class="k-qv__chips" role="radiogroup" aria-label="' + label + '">' +
          p.variants.map(function (x, i) {
            return '<button type="button" class="k-qv__chip' + (i === 0 ? ' is-on' : '') + '"' +
              ' data-vid="' + x.id + '" role="radio" aria-checked="' + (i === 0) + '"' +
              (x.available ? '' : ' disabled') + '>' + x.title + '</button>';
          }).join('') +
          '</div>';
      }
    }

    // The brief rules out crossed-out MRPs, so the compare-at price the
    // product JSON carries is deliberately not rendered.
    var stock = v.available
      ? (p.available ? 'In stock' : '')
      : 'Sold out';
    var blurb = (p.description || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    if (blurb.length > 180) blurb = blurb.slice(0, 180).replace(/\s+\S*$/, '') + '…';

    body.innerHTML =
      '<div class="k-qv__media"><img src="' + (p.featured_image || '') + '" alt="' + p.title.replace(/"/g, '&quot;') + '"></div>' +
      '<div class="k-qv__info">' +
      (p.type ? '<p class="k-qv__type">' + p.type + '</p>' : '') +
      '<h2 class="k-qv__title">' + p.title + '</h2>' +
      '<div class="k-qv__price"><span class="k-qv__now">' + money(v.price) + '</span>' +
      (stock ? '<span class="k-qv__stock' + (v.available ? '' : ' is-out') + '">' + stock + '</span>' : '') +
      '</div>' +
      (blurb ? '<p class="k-qv__blurb">' + blurb + '</p>' : '') +
      opts +
      '<button class="k-btn k-qv__add" type="button"' + (v.available ? '' : ' disabled') + '>' +
      (v.available ? 'Add to bag' : 'Sold out') + '</button>' +
      '<a class="k-qv__full" href="/products/' + p.handle + '">View full details</a>' +
      '</div>';

    var select = body.querySelector('#k-qv-variant');
    var chips = body.querySelectorAll('.k-qv__chip');
    var nowEl = body.querySelector('.k-qv__now');
    var stockEl = body.querySelector('.k-qv__stock');
    var addEl = body.querySelector('.k-qv__add');
    var imgEl = body.querySelector('.k-qv__media img');
    var chosen = p.variants[0].id;

    function current() {
      var id = select ? parseInt(select.value, 10) : chosen;
      return p.variants.filter(function (x) { return x.id === id; })[0] || p.variants[0];
    }

    // Price, availability, the button and the photograph all follow the
    // selection, so the panel never shows a price for one variant beside a
    // picture of another.
    function sync() {
      var cv = current();
      nowEl.textContent = money(cv.price);
      if (stockEl) {
        stockEl.textContent = cv.available ? 'In stock' : 'Sold out';
        stockEl.classList.toggle('is-out', !cv.available);
      }
      if (addEl) {
        addEl.disabled = !cv.available;
        addEl.textContent = cv.available ? 'Add to bag' : 'Sold out';
      }
      if (cv.featured_image && cv.featured_image.src) imgEl.src = cv.featured_image.src;
    }

    if (select) select.addEventListener('change', sync);

    Array.prototype.forEach.call(chips, function (chip) {
      chip.addEventListener('click', function () {
        chosen = parseInt(chip.getAttribute('data-vid'), 10);
        Array.prototype.forEach.call(chips, function (c) {
          var on = c === chip;
          c.classList.toggle('is-on', on);
          c.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        sync();
      });
    });

    body.querySelector('.k-qv__add').addEventListener('click', function (e) {
      var btn = e.currentTarget;
      var cv = current();
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: cv.id, quantity: 1 }] }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Could not add — try again';
        });
    });
  }

  function open(handle, trigger) {
    lastFocus = trigger || null;
    buildModal();
    modal.querySelector('.k-qv__body').innerHTML = '<p class="k-qv__loading">Loading…</p>';
    modal.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';

    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('not found');
        return r.json();
      })
      .then(render)
      .catch(function () {
        modal.querySelector('.k-qv__body').innerHTML =
          '<p class="k-qv__loading">Could not load this product. ' +
          '<a href="/products/' + handle + '">Open its page instead</a>.</p>';
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-k-quickview]');
    if (!btn) return;
    e.preventDefault();
    open(btn.getAttribute('data-k-quickview'), btn);
  });
})();
